import * as React from "react";
import FeatureItemLeftSide from "../templates/featureItemLeft";
import FeatureItemRightSide from "../templates/featureItemRightSide";
import HeroImage from "./../images/homePage/hero-img.png";
import JourneyImage from "./../images/homePage/individualFeatures/journey.png";
import PopupSectionImage from "./../images/homePage/individualFeatures/popups.png";
import SegmentSectionImage from "./../images/homePage/individualFeatures/segments.png";
import CallToAction from "./../templates/callToAction";
import ChannelList from "./../templates/channelsList";
import EnterPriseFeaturesSection from "./../templates/enterpriseFeaturesSection";
import FooterSection from "./../templates/footer";
import HerosectionSecondary from "./../templates/heroSecondarySection";
import NavBar from "./../templates/navbar";
import TestimonialsSection from "./../templates/testomonials";
import BlogsPreview from "./../templates/blogsPreview";
import { Helmet } from "react-helmet";

// Import Icons
import GrowthIcon from "./../images/icons/growth.svg";
import AutomationIcon from "./../images/icons/journey.svg";
import SegmentationIcon from "./../images/icons/customer-attribute.svg";

const info = {
  allFeatures: [
    {
      icon: GrowthIcon,
      title: "Grow Your Customer List",
      description: "Grow your email and SMS list with Popups, Flyouts and other high-converting displays.",
    },
    {
      icon: AutomationIcon,
      title: "Cross-channel Automation",
      description: "Drive more revenue with multi-channel automation built for e-commerce, with ready made automation templates.",
    },
    {
      icon: SegmentationIcon,
      title: "Advanced Segments & Reports",
      description: "Drive action from your consumers at each stage of their lifecycle.",
    },
  ],
  journeyFeatures: [
    {
      id: "abc",
      title: "Send messages on multiple channels",
      description: "Send personalised and contextual messages via Email, SMS, WhatsApp, Push Notifications & many other channels.",
    },
    {
      id: "def",
      title: "Pre-built workflow templates",
      description: "Use high-converting pre-made automations built for e-commerce to get started quickly.",
    },
    {
      id: "ghi",
      title: "Advanced automation reports",
      description: "Measure performance and revenue generted by the workflow. See live view how user moving along in different steps of workflow. Identify the dropouts and revenue loss and optimize workflows further. ",
    },
  ],
};
// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="description" content="Send personalized and targeted messages to your customers based on who they are and how they interact with your business." />
        <meta property="og:image" content={HeroImage} />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Growlytics | Omni-channel Marketing Automation</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      {/* Hero Section */}
      <HerosectionSecondary
        image={HeroImage}
        title1="Drive more revenue with"
        title2="omni-channel marketing"
        description="Send personalized and targeted messages to your customers
        based on who they are and how they interact with your business."
        divideTitlesInNewLine="1"
        paddingRight="pr-0 md:pr-12"
        heavyBackground={true}
      ></HerosectionSecondary>

      {/* <!-- All Features Section --> */}
      <div className="relative sm:mt-5 md:mt-20 bg-gray-50 pt-20 pb-20 sm:pb-50">
        <div className="text-center mb-5">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-badgecolor text-badgetextcolor">All-In-One Marketing & Engagement Platform</span>
        </div>
        <p className="mt-2 text-3xl px-5 font-bold text-gray-900 sm:text-4xl text-center">
          Get everything you need to <br className="hidden md:inline-block" />
          convert first time visitors to repeat buyers
        </p>
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-20">
          <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8 text-center md:text-left">
            {info.allFeatures.map((feature) => (
              <div key={feature.title}>
                <dt>
                  <div className="flex items-center justify-center align-items-center h-12 w-12 rounded-md bg-primary-600 text-white text-center m-auto md:ml-0 ">
                    <img src={feature.icon} className="h-10" />
                  </div>
                  <p className="mt-5 text-lg leading-6 font-medium text-gray-900">{feature.title}</p>
                </dt>
                <dd className="mt-2 text-base text-gray-500 ">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* Messaging ChannelsList */}
      <ChannelList></ChannelList>

      {/* Testimonials Section */}
      <TestimonialsSection></TestimonialsSection>

      {/* Marketing Automation Section */}
      <FeatureItemLeftSide
        features={info.journeyFeatures}
        image={JourneyImage}
        blockStyle="bg-gray-50"
        badge="Marketing Automation"
        title="Build complex marketing journeys, easily."
        description=" Automate communications for different scenarios. Use
          intuitive drag & drop editor to create customer journeys
          with contextual campaigns. It’s as easy as you draw a
          journey on board."
        button={{
          text: "Explore Marketing Automation",
          href: "/features/automation",
        }}
        imageStyle="pr-2 md:pr-0"
      ></FeatureItemLeftSide>

      {/* Segmentation Section */}
      <FeatureItemRightSide
        features={info.journeyFeatures}
        image={SegmentSectionImage}
        badge="Advanced Segmentation"
        title="Engage with your customers based on their profile and behaviour."
        description="Automate communications for different scenarios using customer lifetime value, lifecycle stage, and more."
        button={{
          text: "Explore Customer Segmentation",
          href: "/features/segments",
        }}
        imageStyle="pl-3 md:pl-0"
      ></FeatureItemRightSide>

      {/* Popups Section */}
      <FeatureItemLeftSide
        features={info.journeyFeatures}
        image={PopupSectionImage}
        blockStyle="bg-gray-50"
        badge="Forms - Popups - Flyouts"
        title="Collect data from abandoning visitors."
        description="Growing customer list is first step of tour sales funnel. Use forms and popups and stop loosing valuable abandoning visitors."
        button={{
          text: "Explore Forms & Popups",
          href: "/features/forms-popups",
        }}
        imageStyle="pb-10 md:pb-0"
      ></FeatureItemLeftSide>

      {/* Enterprise Features */}
      <EnterPriseFeaturesSection></EnterPriseFeaturesSection>

      {/* Enterprise Features */}
      <CallToAction></CallToAction>

      {/* Blogs Preview */}
      <BlogsPreview></BlogsPreview>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
